import { Button as AntdButton } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "src/Router";

const Button = styled(AntdButton)`
	margin-bottom: 32px;
	padding: 0px;
	color: #00000073;
	align-self: flex-start;
`;

interface Props {
	path: RoutePath;
}

const ApplicationFormBackButton = ({ path }: Props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<Button type="link" icon={<ArrowLeftOutlined />} onClick={() => navigate(path)}>
			{t("back")}
		</Button>
	);
};

export default ApplicationFormBackButton;
